import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "contact-card" }
const _hoisted_2 = { class: "contact-info" }
const _hoisted_3 = { class: "fullname-text" }
const _hoisted_4 = {
  key: 0,
  class: "job-title"
}
const _hoisted_5 = { class: "company-cell" }
const _hoisted_6 = {
  key: 0,
  class: "mobile-cell"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "empty-cell"
}
const _hoisted_9 = {
  key: 0,
  class: "email-cell"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "empty-cell"
}
const _hoisted_12 = { class: "owner-cell" }
const _hoisted_13 = { class: "popup-body-simple popup-body-modern" }
const _hoisted_14 = { class: "form-content form-content-modern" }
const _hoisted_15 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_16 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_17 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_18 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_19 = { class: "footer-fixed footer-modern" }
const _hoisted_20 = { class: "footer-right" }
const _hoisted_21 = { class: "popup-body-modern" }
const _hoisted_22 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_23 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_24 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_25 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_26 = { class: "form-footer footer-modern" }
const _hoisted_27 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_28 = { class: "popup-body-modern" }
const _hoisted_29 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_30 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_31 = {
  class: "footer-right",
  style: {"margin-top":"20px","text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": _ctx.dsContacts,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      onExporting: _ctx.onExporting,
      onRowClick: _ctx.onRowClick,
      onRowRemoving: _ctx.onRowRemoving,
      "hover-state-enabled": true,
      "remote-operations": true
    }, {
      fullNameTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "avatar",
            style: _normalizeStyle({ backgroundColor: _ctx.getAvatarColor(data.value) })
          }, _toDisplayString(_ctx.getInitials(data.value)), 5),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(data.value), 1),
            (data.data.Titlu)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data.data.Titlu), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      companyTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_5, [
          _cache[24] || (_cache[24] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(data.value), 1)
        ])
      ]),
      mobileTemplate: _withCtx(({ data }) => [
        (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "action-icon-wrapper sales-action" }, [
                _createElementVNode("i", { class: "dx-icon-tel" })
              ], -1)),
              _createElementVNode("a", {
                href: 'tel:' + data.value,
                class: "interactive-link",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, _toDisplayString(data.value), 9, _hoisted_7)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
      ]),
      emailTemplate: _withCtx(({ data }) => [
        (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "action-icon-wrapper support-action" }, [
                _createElementVNode("i", { class: "dx-icon-email" })
              ], -1)),
              _createElementVNode("a", {
                href: 'mailto:' + data.value,
                class: "interactive-link",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, _toDisplayString(data.value), 9, _hoisted_10)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
      ]),
      ownerTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_12, [
          _cache[27] || (_cache[27] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(data.value), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          savingTimeout: 100,
          "storage-key": "gridContacteState"
        }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxPager, {
          "show-page-size-selector": true,
          "allowed-page-sizes": [5, 10, 20],
          "show-info": true,
          "show-navigation-buttons": true
        }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": false,
          allowDeleting: true
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Cauta Contactul",
          "search-visible-columns-only": true
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "plus",
                  type: "success",
                  onClick: _ctx.onAddClick,
                  hint: "Adauga Contact"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick,
                  hint: "Reimprospateaza"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              hint: "Exporta"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          "min-width": 150,
          "cell-template": "fullNameTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Prenume",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Account.Nume",
          caption: "Partener",
          "cell-template": "companyTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TelMobil",
          caption: "Telefon",
          "cell-template": "mobileTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Email",
          caption: "Email",
          "cell-template": "emailTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Owner",
          caption: "Responsabil",
          "cell-template": "ownerTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          visible: false,
          caption: "Nume de Familie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Prenume",
          visible: false,
          caption: "Prenume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataNasterii",
          visible: false,
          caption: "Data Nașterii"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TelMobil",
          visible: false,
          caption: "Telefon Mobil"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tara.Nume",
          caption: "Țară",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Judet.Nume",
          caption: "Județ",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Localitate.Localitate",
          caption: "Localitate",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Adresa",
          visible: false,
          caption: "Adresă"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "MetodaContact",
          visible: false,
          caption: "Metodă Contact"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Note",
          visible: false,
          caption: "Note"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Activ",
          visible: false,
          caption: "Activ"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ContactPrimar",
          visible: false,
          caption: "Contact Primar"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Titlu",
          visible: false,
          caption: "Titlu (Job)"
        }),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          "visible-index": 9999,
          "allow-reordering": false,
          "allow-resizing": false,
          width: "110",
          buttons: [

                    'edit',
                    {
                        name: 'delete',
                        visible: _ctx.isDeleteVisible
                    }
                ]
        }, null, 8, ["buttons"])
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onRowClick", "onRowRemoving"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      onHiding: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isModalVisible = false)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 800,
      height: 610
    }, {
      title: _withCtx(() => [...(_cache[28] || (_cache[28] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare contact"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile contactului în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_DxForm, {
              "form-data": _ctx.formData,
              "col-count": 3,
              "col-span": 3,
              "label-alignment": "center",
              ref: "form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "data-field": "Prenume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Prenume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Nume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Nume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Titlu",
                  label: { text: 'Funcția' },
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Funcția este obligatorie" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Partener' },
                  "col-span": 2,
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Partenerul este obligatoriu" }),
                    _createVNode(_component_DxDropDownBox, {
                      value: _ctx.sPartener,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sPartener) = $event)),
                      "data-source": _ctx.dsParteneri,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      "show-clear-button": true,
                      placeholder: "Selectează partener",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsParteneri,
                            columns: ['Nume'],
                            "hover-state-enabled": true,
                            height: 280,
                            "remote-operations": true,
                            onRowClick: _ctx.onPartenerRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGridToolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxButton, {
                                        icon: "plus",
                                        type: "success",
                                        height: "25px",
                                        width: "25px",
                                        onClick: _ctx.onAddNewPartener
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onRowClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "data-source"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "MetodaContact",
                  label: { text: 'Metodă de Comunicare' },
                  "editor-type": "dxSelectBox",
                  "editor-options": {
                                items: _ctx.metodaContact,
                                placeholder: 'Selectează metoda de comunicare'
                            }
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxFormItem, {
                  "data-field": "TelMobil",
                  label: { text: 'Telefon' }
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Email",
                  label: { text: 'Email' }
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Adresa",
                  label: { text: 'Adresă' },
                  "col-span": 3
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Țară' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsTari,
                      value: _ctx.sTara,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sTara) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează țara",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsTari,
                            columns: ['Nume'],
                            "remote-operations": true,
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onValueSelectedTara($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, { label: { text: 'Județ' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      opened: _ctx.isJudetGridBoxOpened,
                      "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isJudetGridBoxOpened) = $event)),
                      "data-source": _ctx.judetSelectat,
                      value: _ctx.sJudet,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sJudet) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează județul"
                    }, {
                      content: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsJudete,
                            value: _ctx.sJudet,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sJudet) = $event)),
                            columns: ['Nume'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onValueSelectedJudet($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["opened", "data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Localitate' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsLocalitati,
                      value: _ctx.sLocalitate,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sLocalitate) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Localitate",
                      "value-expr": "ID",
                      placeholder: "Selectează localitatea",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsLocalitati,
                            columns: ['Localitate'],
                            "remote-operations": true,
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onValueSelectedLocalitate($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Note",
                  "col-span": 3,
                  "editor-options": { height: 80 },
                  "editor-type": "dxTextArea",
                  label: { text: 'Observații' }
                })
              ]),
              _: 1
            }, 8, ["form-data"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                disabled: !_ctx.formData.AccountID,
                onClick: _ctx.onSaveAdd
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isPartnerModalVisible,
      width: 1450,
      height: 684,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isPartnerModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[29] || (_cache[29] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newPartnerData,
            "col-count": 3,
            "col-span": 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": _ctx.cuiOptions,
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'CUI/CNP' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Nume",
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Nume' este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                                dataSource: _ctx.dsParteneriFiscal,
                                displayExpr: 'Nume',
                                valueExpr: 'Cod',
                                placeholder: 'Selectează Tip Fiscal',
                            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Localitate",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_DxButton, {
                      "element-attr": { class: 'show-more-btn' },
                      text: _ctx.showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare',
                      icon: _ctx.showExtendedDetails ? 'chevronup' : 'chevrondown',
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showExtendedDetails = !_ctx.showExtendedDetails))
                    }, null, 8, ["text", "icon"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Configurare Financiară & Comericală",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, { label: { text: 'Bancă (Internă)' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sBanci,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sBanci) = $event)),
                        "data-source": _ctx.dsBanci,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează bancă",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsBanci,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onBanciRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewBank
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        opened: _ctx.isValutaGridBoxOpened,
                        "onUpdate:opened": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                        "data-source": _ctx.valutaSelectat,
                        value: _ctx.sValuta,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sValuta) = $event)),
                        "show-clear-button": true,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        placeholder: "RON"
                      }, {
                        content: _withCtx(({ data }) => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsValuta,
                            "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onValueSelectedValuta($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ]),
                        _: 1
                      }, 8, ["opened", "data-source", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "CapitalSocial" }),
                  _createVNode(_component_DxFormItem, { "data-field": "CifraAfacere" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "NrAngajati",
                    label: { text: 'Nr. Angajati' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Grup' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sGrupuri,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sGrupuri) = $event)),
                        "data-source": _ctx.dsGrupuri,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 400 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsGrupuri,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onGrupuriRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Zona' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sZona,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.sZona) = $event)),
                        "data-source": _ctx.dsZona,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsZona,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onZonaRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AdaosPret",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scadenta",
                    "col-span": 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Contacte & Diverse",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Tel",
                    label: { text: 'Telefon' }
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "Fax" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Email" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Director" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Observatii",
                    "col-span": 2,
                    "editor-options": { height: 100 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "System Flags",
                visible: _ctx.showExtendedDetails,
                "col-count": 2,
                "col-span": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTVAlaIncasare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'TVA la Încasare' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "RegimSpecialTVA",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Intern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleInternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Extern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleExternChange },
                    label: { text: 'Extern Non UE' }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "ExternUE",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleExternUEChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Client",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Furnizor",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Activ",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTvaDefalcat",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Split TVA' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "faraScadenta",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CalculezPenalitati",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Litigiu",
                    "editor-type": "dxCheckBox"
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_DxButton, {
                text: "Salvează Compania",
                type: "success",
                onClick: _ctx.onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isPartnerModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isBankModalVisible,
      width: 800,
      height: 730,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isBankModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[30] || (_cache[30] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-user" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newBankData,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, { "data-field": "Ordine" }),
              _createVNode(_component_DxFormItem, { "data-field": "Cod" }),
              _createVNode(_component_DxFormItem, { "data-field": "Nume" }),
              _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sValuta,
                    "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.sValuta) = $event)),
                    "data-source": _ctx.dsValuta,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "Selectează ",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsValuta,
                          columns: ['Simbol'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { "data-field": "CodIBAN" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodBIC" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodSWIFT" }),
              _createVNode(_component_DxFormItem, { "data-field": "TextFC" }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_DxButton, {
                text: "Salvează Banca",
                type: "success",
                onClick: _ctx.onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isBankModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}